module.exports = ".warning {\n  color: yellow !important;\n}\n\n.used {\n  color: red !important;\n}\n\ntable {\n    border-collapse: collapse;\n    border-spacing: 0;\n    /*width: 100%;*/\n    /*border: 1px solid #ddd;*/\n}\n\nth, td {\n    text-align: left;\n    padding: 8px;\n}\n\nth{\n  width:150px;\n  font-weight: normal;\n}\n\nth{\n  cursor: pointer;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/user/my-package/my-package.component.css
// module id = ./src/app/user/my-package/my-package.component.css
// module chunks = main